import {SideNavInterface} from '@shared/interfaces/types/side-nav.type';

export const ROUTES: SideNavInterface[] = [
  {
    path: '/explore',
    title: 'Explore',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'eye',
    submenu: []
  },
  // {
  //   path: '/create-research',
  //   title: 'Create Research',
  //   iconType: 'nzIcon',
  //   iconTheme: 'outline',
  //   icon: 'file-text',
  //   submenu: []
  // },
  {
    path: '/view-all-research',
    title: 'Your Car Research',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'file-text',
    submenu: []
  },
  {
    path: '/saved-vehicles',
    title: 'Saved Vehicles',
    iconType: 'nzIcon',
    iconTheme: 'fill',
    icon: 'car',
    submenu: []
  },
  {
    path: '/blogs',
    title: 'Blog',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'read',
    submenu: []
  },
  // {
  //   path: '/sample-research',
  //   title: 'Sample Research',
  //   iconType: 'nzIcon',
  //   iconTheme: 'outline',
  //   icon: 'file-done',
  //   submenu: []
  // },
  {
    path: '/use-cases',
    title: 'Use Cases',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'appstore',
    submenu: [
      {
        path: '/use-cases/buy',
        title: 'Buying',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'experiment',
        submenu: []
      },
      {
        path: '/use-cases/sell',
        title: 'Selling',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'experiment',
        submenu: []
      }
    ]
  }
];
